import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NumbersMainComponent } from './containers/numbers-main/numbers-main.component';

const routes: Routes = [
  { path: '', component: NumbersMainComponent }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NumbersRoutingModule { }
